import React, { useState } from 'react';
import { CheckCircle2Icon, SendIcon } from 'lucide-react';
import { SectionHeading } from '../components/SectionHeading';
import { Button } from '../components/Button';
interface ContactQuestionProps {
  onDownload: () => void;
}
export function ContactQuestion({
  onDownload
}: ContactQuestionProps) {
  const [submitted, setSubmitted] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // eslint-disable-next-line no-console
    console.log('contact_question_submitted', {
      source: 'home_contact'
    });
    setSubmitted(true);
  };
  return <section id="contact" className="w-full scroll-mt-20 bg-sand py-20 lg:py-28" data-id="element-422">
      <div className="mx-auto grid max-w-7xl gap-12 px-5 lg:grid-cols-2 lg:items-start lg:px-8" data-id="element-423">
        <div data-id="element-424">
          <SectionHeading eyebrow="Ask Jordan" title="Have a mine geology systems question?" body="Questions, case study ideas, resource suggestions, or just a conversation about doing geology better — all welcome. Jordan reads every message." data-id="element-425" />
          <div className="mt-7 rounded-xl border border-charcoal/10 bg-cream p-5" data-id="element-426">
            <p className="text-sm font-medium text-charcoal" data-id="element-427">
              Prefer to start with the framework?
            </p>
            <Button variant="secondary" onClick={onDownload} className="mt-3" data-id="element-428">
              Download the Free MGS Toolkit
            </Button>
          </div>
        </div>

        <div className="rounded-2xl border border-charcoal/10 bg-cream p-6 shadow-card lg:p-8" data-id="element-429">
          {submitted ? <div className="flex h-full flex-col items-center justify-center py-8 text-center" data-id="element-430">
              <CheckCircle2Icon className="h-12 w-12 text-improvements" data-id="element-431" />
              <h3 className="mt-4 text-xl font-black text-charcoal" data-id="element-432">
                Thanks for the message
              </h3>
              <p className="mt-2 max-w-sm text-sm leading-relaxed text-warmgray" data-id="element-433">
                Jordan will be in touch. In the meantime, the free guide is a
                good place to start.
              </p>
            </div> : <form onSubmit={handleSubmit} className="space-y-4" data-id="element-434">
              <div className="grid gap-4 sm:grid-cols-2" data-id="element-435">
                <div data-id="element-436">
                  <label htmlFor="c-name" className="mb-1.5 block text-xs font-semibold text-charcoal" data-id="element-437">
                    Name
                  </label>
                  <input id="c-name" required className="mgs-input" placeholder="Your name" data-id="element-438" />
                </div>
                <div data-id="element-439">
                  <label htmlFor="c-email" className="mb-1.5 block text-xs font-semibold text-charcoal" data-id="element-440">
                    Email
                  </label>
                  <input id="c-email" type="email" required className="mgs-input" placeholder="you@example.com" data-id="element-441" />
                </div>
              </div>
              <div data-id="element-442">
                <label htmlFor="c-msg" className="mb-1.5 block text-xs font-semibold text-charcoal" data-id="element-443">
                  What would you like to discuss?
                </label>
                <textarea id="c-msg" required rows={4} className="mgs-input resize-none" placeholder="Your question, idea or suggestion…" data-id="element-444" />
              </div>
              <Button type="submit" variant="primary" className="w-full" data-id="element-445">
                <SendIcon className="h-4 w-4" data-id="element-446" />
                Ask Jordan a Question
              </Button>
            </form>}
        </div>
      </div>
    </section>;
}